export default __webpack_public_path__ + "static/media/pep-token.bc27b8ac.png";